import { FC, useState } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { getBuyersFilterApi } from "api/common";
import { Vessel } from "interface/vessel";
import { ReleasedPackageFilter } from "api/package";
import { getVesselFilter } from "api/vessel";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: ReleasedPackageFilter) => void;
	filterOptions: ReleasedPackageFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState<Partial<ReleasedPackageFilter>>(
		{},
	);

	const applyRegistrationId = () => {
		const newValue = tempFilter.registrationId || "";
		const currentValue = filterOptions.registrationId || "";
		if (newValue === currentValue) return;
		setFilterOptions({
			...filterOptions,
			registrationId: tempFilter.registrationId,
			take: props.pageSize,
			skip: 0,
		});
	};

	const registrationIdValue =
		tempFilter.registrationId == null || tempFilter.registrationId === ""
			? null
			: Number(tempFilter.registrationId);

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselLedgerAccountNumber: vessel.res as any,
			vesselRegistrationId: vessel.rn as any,
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items released-package-filter-items">
				<div
					className="released-package-filter-field"
					style={{ width: "170px" }}
				>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						itemRender={VesselRenderItem()}
						serverFilterApi={getVesselFilter}
					/>
				</div>
				<div
					className="released-package-filter-field"
					style={{ width: "170px" }}
				>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerLedgerAccountNumber || null,
							name: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
				<div
					className="released-package-filter-field"
					style={{ width: "170px" }}
				>
					<NumericTextBox
						className="height-inherit released-package-registration-input"
						label={t("RegistrationId")}
						placeholder=" "
						style={{ width: "100%" }}
						value={
							Number.isNaN(registrationIdValue) ? null : registrationIdValue
						}
						onChange={(e) =>
							setTempFilter({
								...tempFilter,
								registrationId: e.value == null ? undefined : String(e.value),
							})
						}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyRegistrationId();
						}}
						onBlur={() => applyRegistrationId()}
						spinners={false}
						format=""
					/>
				</div>
			</div>

			<div className="filter-end-btn released-package-filter-end-btn">
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
